import consts from "@/consts.js";
import Request from './request';
// Vuex
import store from '@/store.js';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
// i18n
import i18n from '@/i18n';

async function fetch(data) {
    return Request('get', "api/sub-accounts", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/sub-accounts/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/sub-accounts", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["id"]; //仅筛选少许必要字段
    return Request('get', "api/sub-accounts/select", data, false, false, true);
}

async function fetchBankSelect() {// 获取银行备选项列表
    return Request('get', "api/sub-accounts/get-bank-select");
}

async function getAbcBalance(third_account_number) {// 获取农行余额
    return Request('get', "api/sub-accounts/abc-bank-balance/", { third_account_number: third_account_number });
}

async function del(id) {
    return Request('delete', 'api/sub-accounts/delete/' + id)
}

// 新增 编辑 保存
async function save(id, data) {
    if (id) {
        return Request('post', 'api/sub-accounts/edit?id=' + id, data);
    } else {
        return Request('post', 'api/sub-accounts/add', data)
    }
}

async function imports(bank_code, file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/sub-accounts/import?bank_code=" + bank_code, data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/sub-accounts/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function effect(id) {
    return Request('post', "api/sub-accounts/effect?id=" + id);
}

async function checkSubAccountCash(data) {//校验分账提现
    return Request('get', "api/sub-accounts/checkSubAccountCash", data);
}

async function batchCash(data) {//批量提现
    return Request('post', 'api/sub-accounts/batch-cash', data)
}

async function addShop(data) {//添加门店
    return Request('post', 'api/sub-accounts/addShop', data)
}

async function removeShop(data) {//移除门店
    return Request('post', 'api/sub-accounts/removeShop', data)
}

async function fetchBindingShops(id,data) {//获取已绑定的门店
    return Request('get', 'api/sub-accounts/get-binding-shops/' + id,data)
}

async function fetchUnBindingShops(id,data) {//获取未绑定的门店
    return Request('get', 'api/sub-accounts/get-un-binding-shops/' + id,data)
}

export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    fetchBankSelect,
    getAbcBalance,
    del,
    save,
    imports,
    exports,
    effect,
    checkSubAccountCash,
    batchCash,
    addShop,
    removeShop,
    fetchBindingShops,
    fetchUnBindingShops,
};